import loadable from "@loadable/component";


export default loadable(() => import(/* webpackChunkName: "pollingStatusPage.m" */ "./Loadable"));
